<template>
  <div>
    <img class="button-g"
         v-if="pengWu[598695]!=0"
         src="/images/n95/buy.png"
         :style="{top:oneGoodsTop,left:buttonLeft}"
         @click="addViewHistory2(598695)" />
    <img class="button-g"
         v-if="pengWu[598696]!=0"
         src="/images/n95/buy.png"
         :style="{top:twoGoodsTop,left:buttonLeft}"
         @click="addViewHistory2(598696)" />
    <!-- <img class="button-g"
         v-if="pengWu[598697]!=0"
         src="/images/n95/buy.png"
         :style="{top:threeGoodsTop,left:buttonLeft}"
         @click="addViewHistory2(598697)" /> -->

    <img class="button-g"
         v-if="pengWu[598695]==0"
         src="/images/n95/noBug.png"
         :style="{top:oneGoodsTop,left:buttonLeft}" />
    <img class="button-g"
         v-if="pengWu[598696]==0"
         src="/images/n95/noBug.png"
         :style="{top:twoGoodsTop,left:buttonLeft}" />
    <!-- <img class="button-g"
         v-if="pengWu[598697]==0"
         src="/images/n95/noBug.png"
         :style="{top:threeGoodsTop,left:buttonLeft}" /> -->

    <!-- 非小程序 -->
    <div v-if="!miniScene">
      <a href="https://mi.baozheng.cc/serviceDetail?serviceId=55&source=4"><img class="button-g"
             src="/images/n95/buy.png"
             :style="{top:fourGoodsTop,left:buttonLeft}" /></a>
      <a href="https://mi.baozheng.cc/serviceDetail?serviceId=56&source=11"><img class="button-g"
             src="/images/n95/buy.png"
             :style="{top:fiveGoodsTop,left:buttonLeft}" /></a>

      <img class="button-1"
           src="/images/n95/codeOne.png"
           :style="{top:codeOne.height,left:codeOne.width}" />
      <img class="button-2"
           src="/images/n95/codeTwo.png"
           :style="{top:codeTwo.height,left:codeTwo.width}" />
      <img class="button-2"
           src="/images/n95/codeThree.png"
           :style="{top:codeThree.height,left:codeThree.width}" />
      <div v-for="(im,index) in imgas">
        <img :src="im.url"
             v-if="index==3"
             @click="addViewHistory2(598695)"
             :style="{width:clientWidth}" />
        <img :src="im.url"
             v-if="index==4"
             @click="addViewHistory2(598696)"
             :style="{width:clientWidth}" />
        <!-- <img :src="im.url"
           v-if="index==5"
           @click="addViewHistory2(598697)"
           :style="{width:clientWidth}" /> -->
        <img :src="im.url"
             v-if="index!=5&&index!=3&&index!=4&&index!=8&&index!=7"
             :style="{width:clientWidth}" />
        <a v-if="index==7"
           href="https://mi.baozheng.cc/serviceDetail?serviceId=55&source=4"> <img :src="im.url"
               :style="{width:clientWidth}" /></a>
        <a v-if="index==8"
           href="https://mi.baozheng.cc/serviceDetail?serviceId=56&source=11"> <img :src="im.url"
               :style="{width:clientWidth}" /></a>
      </div>

    </div>

    <!-- 小程序 -->
    <div v-if="miniScene">

      <img class="button-1"
           src="/images/n95/codeOne.png"
           :style="{top:codeOne2.height,left:codeOne.width}" />
      <img class="button-2"
           src="/images/n95/codeTwo.png"
           :style="{top:codeTwo2.height,left:codeTwo.width}" />
      <img class="button-2"
           src="/images/n95/codeThree.png"
           :style="{top:codeThree2.height,left:codeThree.width}" />
      <div v-for="(im,index) in imgas">
        <img :src="im.url"
             v-if="index==3"
             @click="addViewHistory2(598695)"
             :style="{width:clientWidth}" />
        <img :src="im.url"
             v-if="index==4"
             @click="addViewHistory2(598696)"
             :style="{width:clientWidth}" />
        <!-- <img :src="im.url"
           v-if="index==5"
           @click="addViewHistory2(598697)"
           :style="{width:clientWidth}" /> -->
        <img :src="im.url"
             v-if="index!=5&&index!=3&&index!=4&&index!=8&&index!=7"
             :style="{width:clientWidth}" />
      </div>

    </div>

  </div>
</template>

<script>
import homeApi from "@api/home";
import regObj from '@utils/reg'
import { mapActions, mapState } from 'vuex'
import wxShare from '@utils/wx.share'
import publicObj from '@utils/public'
import wx from 'weixin-js-sdk'

export default {
  name: "index",
  data() {
    return {
      isAgree: false,
      activeIndex: null,
      mobile: '',
      code: '',
      isSendCodeFlag: false,
      bindKey: null,
      width: '',
      pengWu: { '598695': 0, '598696': 0, '598697': 0 },
      imgas: [],
      miniScene: (window.location.href.indexOf('from=chenzhen') !== -1)
    }
  },
  watch: {},
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    clientWidth() {
      return document.documentElement.clientWidth + 'px'
    },
    buttonLeft() {
      return document.body.clientWidth / 750 * 430 + 'px'
    },
    oneGoodsTop() {
      return document.body.clientWidth / 750 * 2068 + 'px'
    },
    twoGoodsTop() {
      return document.body.clientWidth / 750 * 2832 + 'px'
    },
    threeGoodsTop() {
      return document.body.clientWidth / 750 * 3596 + 'px'
    },
    fourGoodsTop() {
      return document.body.clientWidth / 750 * 4084 + 'px'
    },
    fiveGoodsTop() {
      return document.body.clientWidth / 750 * 4760 + 'px'
    },
    codeOne() {
      return {
        height: document.body.clientWidth / 750 * 5102 + 'px',
        width: document.body.clientWidth / 750 * 196 + 'px',
      }
    },
    codeTwo() {
      return {
        height: document.body.clientWidth / 750 * 5898 + 'px',
        width: document.body.clientWidth / 750 * 144 + 'px',
      }
    },
    codeThree() {
      return {
        height: document.body.clientWidth / 750 * 5898 + 'px',
        width: document.body.clientWidth / 750 * 452 + 'px',
      }
    },

    // 小程序
    codeOne2() {
      // 3750
      return {
        height: document.body.clientWidth / 750 * 3750 + 'px',
        width: document.body.clientWidth / 750 * 196 + 'px',
      }
    },
    codeTwo2() {
      return {
        height: document.body.clientWidth / 750 * 4546 + 'px',
        width: document.body.clientWidth / 750 * 144 + 'px',
      }
    },
    codeThree2() {
      return {
        height: document.body.clientWidth / 750 * 4546 + 'px',
        width: document.body.clientWidth / 750 * 452 + 'px',
      }
    }
  },
  created() {
    if (window.location.href.indexOf('from=fwyy') !== -1) {
      zhuge.track('进入”包青天“专题页', {
        '进入来源': '包拯服务运营',
        '用户id': this.userInfo ? this.userInfo.userId : ''
      });
    } else if (window.location.href.indexOf('from=bzpyq') !== -1) {
      zhuge.track('进入”包青天“专题页', {
        '进入来源': '包拯朋友圈',
        '用户id': this.userInfo ? this.userInfo.userId : ''
      });
    } else if (window.location.href.indexOf('from=baozheng') !== -1) {
      zhuge.track('进入”包青天“专题页', {
        '进入来源': '包拯H5',
        '用户id': this.userInfo ? this.userInfo.userId : ''
      });
    } else if (window.location.href.indexOf('from=czfwyy') !== -1) {
      zhuge.track('进入”包青天“专题页', {
        '进入来源': '陈真服务运营1vs1',
        '用户id': this.userInfo ? this.userInfo.userId : ''
      });
    } else if (window.location.href.indexOf('from=chenzhen') !== -1) {
      zhuge.track('进入”包青天“专题页', {
        '进入来源': '陈真H5',
        '用户id': this.userInfo ? this.userInfo.userId : ''
      });
    }
  },
  mounted() {
    wxShare({
      title: '包清天—消毒一步到位',
      desc: '你的困扰我来解决，专属消毒服务“鼠”于你',
      imgUrl: 'https://img.chenzhen.shop/2020/02/09/870f477a-b010-4254-b421-21fc6a75bb9a.png'
    })
    this.width = document.body.clientWidth
    this.getAll()
    let list = []
    for (let i = 1; i < 12; i++) {
      list.push({ url: '/images/n95/' + i + '.png' })
    }
    this.imgas = list
  },
  methods: {
    addViewHistory2(sku) {
      if (this.miniScene) { //小程序环境
        wx.miniProgram.navigateTo({
          url: '/pages/home/proDetail/index?id=' + sku
        });
      } else {
        this.$router.push({ name: 'proDetail', query: { id: sku } })
        if (this.userInfo && this.userInfo.token) {
          homeApi.addViewHistory({ sku });
        }
      }

    },

    getAll() {
      let { pengWu } = this
      for (let obj in pengWu) {
        homeApi
          .getProDetail(obj)
          .then(res => {
            pengWu[res.id] = res.stock
            console.log(res)
          })
      }
    },
    getDitailBySku() {
      homeApi
        .getProDetail(598697)
        .then(res => {
          console.log(res)
        })
    },
  },
}
</script>

<style lang="css" scoped>
img {
  vertical-align: top;
}
.button-g {
  width: 288px;
  height: 108px;
  position: absolute;
  right: 20px;
}
.button-1 {
  width: 360px;
  height: 360px;
  position: absolute;
}
.button-2 {
  width: 156px;
  height: 156px;
  position: absolute;
}
</style>
